import { render, staticRenderFns } from "./AdsPropertyList.vue?vue&type=template&id=19c323c0"
import script from "./AdsPropertyList.vue?vue&type=script&lang=js"
export * from "./AdsPropertyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports